import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiCopy, FiAlertTriangle, FiArrowLeft } from 'react-icons/fi';
import logger from '@/utils/logger';

function DropboxCallback() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    logger.success('Authorization code copied to clipboard.');
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="max-w-xl w-full bg-white rounded-lg shadow-lg p-8">
        {code ? (
          <>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Dropbox Authorization Code</h1>
            <p className="text-gray-600 mb-4">
              Copy this code. You will need it to generate your `DROPBOX_REFRESH_TOKEN`. This is a one-time use code.
            </p>
            <div className="flex items-center space-x-2 mb-6">
              <input
                readOnly
                value={code}
                className="w-full p-2 font-mono text-sm bg-gray-100 border border-gray-300 rounded-md"
              />
              <button onClick={handleCopy} className="p-2 text-gray-600 hover:bg-gray-200 rounded-md">
                <FiCopy className="h-5 w-5" />
              </button>
            </div>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <p className="text-sm text-yellow-800">
                    <strong>Next Step:</strong> Use this code with a cURL command or a tool like Postman to get your refresh token. See the Setup Guides for detailed instructions.
                </p>
            </div>
          </>
        ) : (
          <div className="text-center">
            <FiAlertTriangle className="mx-auto h-12 w-12 text-red-400 mb-4" />
            <h1 className="text-2xl font-bold text-red-800 mb-2">Authorization Failed</h1>
            <p className="text-gray-600">No authorization code was found in the URL. Please try the authorization process again.</p>
          </div>
        )}
        <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/setup-guides')}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              <FiArrowLeft className="mr-2" />
              Back to Setup Guides
            </button>
        </div>
      </div>
    </motion.div>
  );
}

export default DropboxCallback;